// this file added by Bearer Web Developer
import React from 'react';
import { useAppState } from '../../states/app-state';
import styles from './inviteCode.module.scss';
import { Button } from '@mui/material';

const InviteCode: React.FC = () => {
  const appState = useAppState();
  const { shareTextField, copyTextField } = appState?.inviteCode;
  const inviteCodeValue = appState?.inviteCode?.getInviteCodeValue();
  const handleShare = () => {
    if (navigator && !!navigator?.share) {
      shareTextField(inviteCodeValue)
    } else if (navigator && navigator?.clipboard) {
      copyTextField(inviteCodeValue)
    }
  }
  return (
    <section className={styles.invite_code}>
      <div className={styles.copy}>
        <div className={styles.invite}>
          <img src="/invite-code-star.svg" alt="" width={24} height={24} />
          <p>Invite Friends to Bearer!</p>
        </div>
        <Button className={styles.code} onClick={handleShare}>
          <img src="/copy-content.webp" alt="" width={24} height={24} />
          <p className={styles.text_desktop}>Copy Invitation Text</p>
          <p className={styles.text_mobile}>Copy Text</p>
        </Button>
      </div>
      <div className={styles.close} onClick={() => { appState?.inviteCode?.setOpen(false) }}>
        <img src="/close-white.svg" alt="" width={24} height={24} />
      </div>
    </section>
  );
}
export default InviteCode;